import { processRequest } from './network/managedRequest';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { API } from '../constants';
import { PbRequest } from './pbRequest';
import { PbDispatch } from './index';

interface ChangeEmailDto {
    updated_email: string;
}
export interface ConfirmChangeEmailDto {
    verification_code: string;
    ctime?: number;
    updated_email?: string;
}

export interface SuccessDto {
    status: number;
    message: string;
    timestamp: number;
}

interface ChangeEmailStore {
    changeEmailData?: ConfirmChangeEmailDto;
}

const initialState: ChangeEmailStore = {
    changeEmailData: undefined,
};
export const changeEmailSlice = createSlice({
    name: 'changeEmailSlice',
    initialState,
    reducers: {
        setChangeEmailData(
            state: ChangeEmailStore,
            action: PayloadAction<ConfirmChangeEmailDto>
        ) {
            state.changeEmailData = action.payload;
        },
    },
});

export function RequestEmailChange(email: string) {
    return async (dispatch: PbDispatch) => {
        try {
            const body: ChangeEmailDto = {
                updated_email: email,
            };
            const request: RequestInit = {
                method: 'POST',
                body: JSON.stringify(body),
            };
            await processRequest(
                dispatch,
                `${API}/partners/me/email`,
                request,
                PbRequest.CHANGE_EMAIL
            );
        } catch {}
    };
}

export function RequestConfirmEmailChange(code: string) {
    return async (dispatch: PbDispatch) => {
        try {
            const body: ConfirmChangeEmailDto = {
                verification_code: code,
            };
            const request: RequestInit = {
                method: 'POST',
                body: JSON.stringify(body),
            };
            await processRequest(
                dispatch,
                `${API}/partners/me/email-change-verification`,
                request,
                PbRequest.CONFIRM_CHANGE_EMAIL
            );
        } catch {}
    };
}

export function getEmailChangeRequest(code: string) {
    return async (dispatch: PbDispatch) => {
        try {
            const request: RequestInit = {
                method: 'GET',
            };
            const result = await processRequest<ConfirmChangeEmailDto>(
                dispatch,
                `${API}/partners/me/email/${code}`,
                request,
                PbRequest.GET_CHANGE_EMAIL
            );
            dispatch(changeEmailSlice.actions.setChangeEmailData(result));
        } catch {}
    };
}

export function getConfirmEmailChange() {
    return async (dispatch) => {
        try {
            const request: RequestInit = {
                method: 'GET',
            };
            const result = await processRequest<ConfirmChangeEmailDto>(
                dispatch,
                `${API}/partners/me/email`,
                request,
                PbRequest.GET_CHANGE_EMAIL
            );
            dispatch(changeEmailSlice.actions.setChangeEmailData(result));
        } catch {}
    };
}

export default changeEmailSlice.reducer;
